import { DashboardModule } from '@campaignhub/suit-theme'

import { generateUrls } from '@hooks/useContact'
import useSubscriptions from '@hooks/useSubscriptions'

import ListBlankState from '@components/ListBlankState'
import Subscription from './Subscription'

const Subscriptions = (props: { contactId: number }) => {
  const { contactId } = props

  const { editContactSubscriptionsUrl } = generateUrls({ id: contactId })

  const subscriptionsPayload = useSubscriptions({
    filters: {
      contactId,
      // need to filter status to active subscriptions
    },
    performHttpRequests: !!contactId,
    requestOptions: {
      includeSubscriptionTotals: !!contactId,
    },
  })

  const {
    loading,
    filteredSubscriptions,
    hasFilteredSubscriptions,
  } = subscriptionsPayload || {}

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.Link href={editContactSubscriptionsUrl}>View All</DashboardModule.Link>}
      loading={loading}
      title="Active Subscriptions"
    >
      {!loading && !hasFilteredSubscriptions && <ListBlankState title="No Subscriptions" text=" " />}

      {!loading && hasFilteredSubscriptions && (
        <DashboardModule.ScrollableSection>
          {filteredSubscriptions.map(subscription => (
            <Subscription
              key={subscription.id}
              subscription={subscription}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default Subscriptions
